import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Col, Row, Form } from "react-bootstrap";
import { AdminRum } from "../../types";

const countryChoices = [
    "Antigua and Barbuda","Australia","Austria", "Bahamas", "Barbados", 
    "Belize", "Bermuda", "Brazil", "British Virgin Islands", "Cambodia",
    "Canada", "Cape Verde", "Cayman Islands", "Colombia", "Costa Rica", 
    "Cuba", "Denmark", "Dominican Republic", "Dominica", "Earth", "Ecuador", 
    "El Salvador", "Fiji", "Grenada", 
    "Guadeloupe", "Guatemala", "Guyana", "Haiti", 
    "India", "Italy", "Indonesia", "Jamaica", "Japan", "Madagascar", 
    "Marie-Galante", "Martinique", "Mauritius", "Mexico", 
    "N/A", "Navy Style", "Nepal", "New Zealand", 
    "Nicaragua", "Panama", "Paraguay", "Peru", "Philippines", "Portugal", 
    "Puerto Rico", "Reunion", "Royal Navy Rum", "Saint Kitts and Nevis", "Saint Lucia", 
    "Saint Vincent and the Grenadines", "Seychelles", "South Africa", 
    "Spain", "Sri Lanka", "Taiwan", "Tahiti", "Thailand", "Trinidad and Tobago", 
    "Turks and Caicos Islands","United Kingdom", "United States",
    "Venezuela", "Virgin Islands", "Regional Blend"
];

const levelOptions = [
    "Any Level",
    "Initiate",
    "Disciple",
    "Guardian",
    "Master",
    "Black Tassel",
    "Legend",
    "Constable"
];

const stateChoices: [string, string][] = [
    ['AK', 'Alaska'],
    ['AL', 'Alabama'],
    ['AR', 'Arkansas'],
    ['AZ', 'Arizona'],
    ['CA', 'California'],
    ['CO', 'Colorado'],
    ['CT', 'Connecticut'],
    ['DC', 'District of Columbia'],
    ['DE', 'Delaware'],
    ['FL', 'Florida'],
    ['GA', 'Georgia'],
    ['HI', 'Hawaii'],
    ['IA', 'Iowa'],
    ['ID', 'Idaho'],
    ['IL', 'Illinois'],
    ['IN', 'Indiana'],
    ['KS', 'Kansas'],
    ['KY', 'Kentucky'],
    ['LA', 'Louisiana'],
    ['MA', 'Massachusetts'],
    ['MD', 'Maryland'],
    ['ME', 'Maine'],
    ['MI', 'Michigan'],
    ['MN', 'Minnesota'],
    ['MO', 'Missouri'],
    ['MS', 'Mississippi'],
    ['MT', 'Montana'],
    ['NC', 'North Carolina'],
    ['ND', 'North Dakota'],
    ['NE', 'Nebraska'],
    ['NH', 'New Hampshire'],
    ['NJ', 'New Jersey'],
    ['NM', 'New Mexico'],
    ['NV', 'Nevada'],
    ['NY', 'New York'],
    ['OH', 'Ohio'],
    ['OK', 'Oklahoma'],
    ['OR', 'Oregon'],
    ['PA', 'Pennsylvania'],
    ['RI', 'Rhode Island'],
    ['SC', 'South Carolina'],
    ['SD', 'South Dakota'],
    ['TN', 'Tennessee'],
    ['TX', 'Texas'],
    ['UT', 'Utah'],
    ['VA', 'Virginia'],
    ['VT', 'Vermont'],
    ['WA', 'Washington'],
    ['WI', 'Wisconsin'],
    ['WV', 'West Virginia'],
    ['WY', 'Wyoming'],
];

interface AdminRumModalProps {
    closeModal: () => void;
    show: boolean;
    rum: AdminRum | null;
    save: (rum: any) => void;
}

export default function AdminRumModal({ closeModal, show, rum, save}: AdminRumModalProps): JSX.Element {    

    if(!rum) {
        return (
            <></>
        )
    }

    function saveRum(): void {

        let rumToUpdate: Partial<AdminRum> = {
            bevager_name: (document.getElementById("bevager_name") as HTMLInputElement)?.value || '',
            is_independent_bottler: (document.getElementById("is_independent_bottler") as HTMLInputElement)?.checked || false,
            is_event: (document.getElementById("is_event") as HTMLInputElement)?.checked || false,
            is_smugglers_cove_private_bottling: (document.getElementById("is_smugglers_cove_private_bottling") as HTMLInputElement)?.checked || false,
            pour_size: (document.getElementById("pour_size") as HTMLSelectElement)?.value,
            is_migrated: (document.getElementById("is_migrated") as HTMLInputElement)?.checked || false,
            is_immortal: (document.getElementById("is_immortal") as HTMLInputElement)?.checked || false,
            is_shown: (document.getElementById("is_shown") as HTMLInputElement)?.checked || false,
            is_available: (document.getElementById("is_available") as HTMLInputElement)?.checked || false,
            price: parseFloat((document.getElementById("price") as HTMLInputElement)?.value || '0'),
            level_limit: parseInt((document.getElementById("level_limit") as HTMLSelectElement)?.value || '0'),
        };

        if(rum && !!rum.id) {
            rumToUpdate.id = rum.id;
        }

        if(rum && !!(rum as any).bevager_id) {
            (rumToUpdate as any).bevager_id = (rum as any).bevager_id;
        }

        //brand name
        const brand_name = (document.getElementById("brand_name") as HTMLInputElement)?.value;
        if(brand_name) {
            (rumToUpdate as any).brand_name = brand_name;
        } else {
            (rumToUpdate as any).brand_name = null;
        }
        //priduct name
        const product_name = (document.getElementById("product_name") as HTMLInputElement)?.value;
        if(product_name) {
            (rumToUpdate as any).product_name = product_name;
        } else {
            (rumToUpdate as any).product_name = null;
        }
        //us state
        const us_state = (document.getElementById("us_state") as HTMLSelectElement)?.value;
        if(us_state) {
            (rumToUpdate as any).us_state = us_state;
        } else {
            (rumToUpdate as any).us_state = null;
        }
        //distillery
        const distillery = (document.getElementById("distillery") as HTMLInputElement)?.value;
        if(distillery) {
            (rumToUpdate as any).distillery = distillery;
        } else {
            (rumToUpdate as any).distillery = null;
        }
        //cask finish
        const cask_finish = (document.getElementById("cask_finish") as HTMLInputElement)?.value;
        if(cask_finish) {
            (rumToUpdate as any).cask_finish = cask_finish;
        } else {
            (rumToUpdate as any).cask_finish = null;
        }
        //year distilled
        const year_distilled = (document.getElementById("year_distilled") as HTMLInputElement)?.value;
        if(year_distilled) {
            (rumToUpdate as any).year_distilled = parseInt(year_distilled);
        } else {
            (rumToUpdate as any).year_distilled = null;
        }
        //year bottled
        const year_bottled = (document.getElementById("year_bottled") as HTMLInputElement)?.value;
        if(year_bottled) {
            (rumToUpdate as any).year_bottled = parseInt(year_bottled);
        } else {
            (rumToUpdate as any).year_bottled = null;
        }
        //age
        const age = (document.getElementById("age") as HTMLInputElement)?.value;
        if(age) {
            (rumToUpdate as any).age = age;
        } else {
            (rumToUpdate as any).age = null;
        }
        //marque
        const marque = (document.getElementById("marque") as HTMLInputElement)?.value;
        if(marque) {
            (rumToUpdate as any).marque = marque;
        } else {
            (rumToUpdate as any).marque = null;
        }
        //alcohol percentage
        const alcohol_percentage = (document.getElementById("alcohol_percentage") as HTMLInputElement)?.value;
        if(alcohol_percentage) {
            (rumToUpdate as any).alcohol_percentage = parseFloat(alcohol_percentage);
        } else {
            (rumToUpdate as any).alcohol_percentage = null;
        }
        //cove notes
        const cove_notes = (document.getElementById("cove_notes") as HTMLInputElement)?.value;
        if(cove_notes) {
            (rumToUpdate as any).cove_notes = cove_notes;
        } else {
            (rumToUpdate as any).cove_notes = null;
        }
        //production method
        const production_method = (document.getElementById("production_method") as HTMLSelectElement)?.value;
        if(production_method) {
            (rumToUpdate as any).production_method = production_method;
        } else {
            (rumToUpdate as any).production_method = null;
        }
        //raw material
        const raw_material = (document.getElementById("raw_material") as HTMLSelectElement)?.value;
        if(raw_material) {
            (rumToUpdate as any).raw_material = raw_material;
        } else {
            (rumToUpdate as any).raw_material = null;
        }
        //origin country
        const origin_country = (document.getElementById("origin_country") as HTMLSelectElement)?.value;
        if(origin_country) {
            (rumToUpdate as any).origin_country = origin_country;
        } else {
            (rumToUpdate as any).origin_country = null;
        }
        //pour size notes
        const pour_size_notes = (document.getElementById("pour_size_notes") as HTMLInputElement)?.value;
        if(pour_size_notes) {
            (rumToUpdate as any).pour_size_notes = pour_size_notes;
        } else {
            (rumToUpdate as any).pour_size_notes = null;
        }

        save(rumToUpdate);
    }

    return (
        <>
        <Modal show={show} onHide={closeModal} size="lg">
            <Modal.Header closeButton>
            <Modal.Title>{rum.bevager_name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col>
                        RumID: {rum.inventory_id}
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        <Form.Label htmlFor="bevager_name">Bevager Name:</Form.Label>
                        <Form.Control
                            type="text"
                            id="bevager_name"
                            defaultValue={rum.bevager_name}
                        />
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        <Form.Label htmlFor="brand_name">Brand Name:</Form.Label>
                        <Form.Control
                            type="text"
                            id="brand_name"
                            defaultValue={(rum as any).brand_name}
                        />
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        <Form.Label htmlFor="product_name">Product Name:</Form.Label>
                        <Form.Control
                            type="text"
                            id="product_name"
                            defaultValue={(rum as any).product_name}
                        />
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        Origin Country:
                        <Form.Select id="origin_country" defaultValue={rum.origin_country}>
                            <option value="">-----</option>
                            {countryChoices.map( function(country, i) {
                                return (
                                    <option key={i} value={country}>{country}</option>
                                )
                            })}
                        </Form.Select>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        US State:
                        <Form.Select id="us_state" defaultValue={(rum as any).us_state}>
                            <option value="">-----</option>
                            {stateChoices.map( function(stateArray, i) {
                                return (
                                    <option key={i} value={stateArray[0]}>{stateArray[1]}</option>
                                )
                            })}
                        </Form.Select>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        <Form.Label htmlFor="cask_finish">Cask Finish:</Form.Label>
                        <Form.Control
                            type="text"
                            id="cask_finish"
                            defaultValue={(rum as any).cask_finish}
                        />
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        <Form.Label htmlFor="distillery">Distillery:</Form.Label>
                        <Form.Control
                            type="text"
                            id="distillery"
                            defaultValue={(rum as any).distillery}
                        />
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        Raw Material:
                        <Form.Select id="raw_material" defaultValue={rum.raw_material}>
                            <option value="">-----</option>
                            <option value="Molasses">Molasses</option>
                            <option value="Fresh Cane Juice">Fresh Cane Juice</option>
                            <option value="Sugar Cane Syrup">Sugar Cane Syrup</option>
                            <option value="Evaporated Cane Juice">Evaporated Cane Juice</option>
                            <option value="Multiple">Multiple</option>
                        </Form.Select>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        <Form.Check
                            type="checkbox"
                            label="Is Independent Bottler"
                            id='is_independent_bottler'
                            defaultChecked={rum.is_independent_bottler}
                        />
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        <Form.Check
                            type="checkbox"
                            label="Is Event"
                            id='is_event'
                            defaultChecked={rum.is_event}
                        />
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        <Form.Check
                            type="checkbox"
                            label="Is Cove Private Bottling"
                            id='is_smugglers_cove_private_bottling'
                            defaultChecked={rum.is_smugglers_cove_private_bottling}
                        />
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        <Form.Label htmlFor="year_distilled">Year Distilled:</Form.Label>
                        <Form.Control
                            type="number"
                            id="year_distilled"
                            defaultValue={(rum as any).year_distilled}
                        />
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        <Form.Label htmlFor="year_bottled">Year Bottled:</Form.Label>
                        <Form.Control
                            type="number"
                            id="year_bottled"
                            defaultValue={(rum as any).year_bottled}
                        />
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        <Form.Label htmlFor="age">Age:</Form.Label>
                        <Form.Control
                            type="text"
                            id="age"
                            defaultValue={(rum as any).age}
                        />
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        <Form.Label htmlFor="marque">Marque:</Form.Label>
                        <Form.Control
                            type="text"
                            id="marque"
                            defaultValue={(rum as any).marque}
                        />
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        <Form.Label htmlFor="alcohol_percentage">Alcohol Percentage:</Form.Label>
                        <Form.Control
                            type="number"
                            id="alcohol_percentage"
                            defaultValue={(rum as any).alcohol_percentage}
                        />
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        <Form.Label htmlFor="cove_notes">Cove Notes:</Form.Label>
                        <Form.Control
                            type="text"
                            id="cove_notes"
                            defaultValue={(rum as any).cove_notes}
                        />
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        Production Method
                        <Form.Select id="production_method" defaultValue={(rum as any).production_method}>
                            <option value="">----</option>
                            <option value="Pot">Pot</option>
                            <option value="Column">Column</option>
                            <option value="Blend (pot & column)">Blend (pot & column)</option>
                            <option value="Coffey Still">Coffey Still</option>
                            <option value="Creole Column Still">Creole Column Still</option>
                            <option value="Multi-Column Still">Multi-Column Still</option>
                        </Form.Select>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        <Form.Check
                            type="checkbox"
                            label="Is Immortal"
                            id='is_immortal'
                            defaultChecked={rum.is_immortal}
                        />
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        <Form.Label htmlFor="price">Price:</Form.Label>
                        <Form.Control
                            type="number"
                            id="price"
                            defaultValue={rum.price}
                        />
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        <Form.Check
                            type="checkbox"
                            label="Is Shown"
                            id='is_shown'
                            defaultChecked={rum.is_shown}
                        />
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        <Form.Check
                            type="checkbox"
                            label="Is Available"
                            id='is_available'
                            defaultChecked={rum.is_available}
                        />
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        Pour Size
                        <Form.Select id="pour_size" defaultValue={rum.pour_size}>
                            <option value="1">1 oz</option>
                            <option value="2">2 oz</option>
                            <option value="other">Other</option>
                        </Form.Select>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        <Form.Label htmlFor="pour_size_notes">Pour Size Notes:</Form.Label>
                        <Form.Control
                            type="text"
                            id="pour_size_notes"
                            defaultValue={(rum as any).pour_size_notes}
                        />
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        <Form.Check
                            type="checkbox"
                            label="Is Migrated"
                            id='is_migrated'
                            defaultChecked={rum.is_migrated}
                        />
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        Level Limit:
                        <Form.Select id="level_limit" defaultValue={rum.level_limit}>
                            {levelOptions.map( function(level, i) {
                                return (
                                    <option key={i} value={i}>{level}</option>
                                )
                            })}
                        </Form.Select>
                    </Col>
                </Row>
                <hr />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={saveRum}>
                    { !!rum.id ? "Save Changes" : "Add Rum" }
                </Button>
            </Modal.Footer>
        </Modal>
        </>
    );
}
